import { googleAnalyticsAuthFactory } from '@my-backoffice/app/shared/factories/google-analytics/google-analytics-auth.factory';
import { GOOGLE_ANALYTICS_AUTH } from '@my-backoffice/app/shared/tokens/google-analytics-auth.token';
import { WINDOW } from '@my-backoffice/app/shared/tokens/window.token';
import { FactoryProvider } from '@angular/core';

export const GOOGLE_ANALYTICS_AUTH_PROVIDER: FactoryProvider = {
  deps: [WINDOW],
  useFactory: googleAnalyticsAuthFactory,
  provide: GOOGLE_ANALYTICS_AUTH,
};
